import * as React from "react"
import {batch} from "@preact/signals-react";
import {ToggleButtonSeeker} from "@ui-seeker/core";

import {GROUPED_BY} from "@constants";
import {shareOfSearchCurrentTab, shareOfSearchCurrentTabNormalize} from "../@signals";


const TABS = [
	{ value: GROUPED_BY.COUNTRY, label: 'Market' },
	{ value: GROUPED_BY.RETAILER, label: 'Retailer' },
	{ value: GROUPED_BY.CATEGORY, label: 'Category' },
	{ value: GROUPED_BY.BRAND, label: 'Brand' }
]

export default function ShareOfSearchActions() {
    return <ToggleButtonSeeker
        value={shareOfSearchCurrentTab.value}
        onChange={(_, newValue) => batch(() => {
			shareOfSearchCurrentTab.value = newValue
			shareOfSearchCurrentTabNormalize.value = TABS.filter(({ value }) => value === newValue)[0].label
		})}
		tabs={TABS}
    />
}